import React from "react";

export default ({ isSuper, isAgent, userData, children }) => (
  <div className="SubPage">
    <div className="SubPage_body">
      {React.cloneElement(children, { isSuper, isAgent, userData })}
    </div>
  </div>
);
